var _path, _path2, _path3, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 106,
    viewBox: "0 0 87 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8689 14.9031C10.6431 23.5051 11.7182 35.3329 27.8471 40.7092C39.1373 45.0102 48.8585 39.5958 52.5779 43.9349C55.8037 47.6983 50.1563 51.3212 55.8037 65.44C57.9542 70.8163 62.2552 72.9668 63.3305 79.4183C64.4057 85.8699 60.8889 94.9336 64.9433 100.923C67.9057 105.3 74.9141 105.368 75.1582 98.7729C75.4023 92.1774 78.384 92.3214 78.9216 88.558C79.4593 84.7946 77.2196 81.048 79.4593 77.2678C84.0692 68.638 85.4909 63.8095 84.8356 55.2251C84.3836 49.3041 83.2226 47.1607 83.2226 40.7092C83.2226 33.1824 86.1418 31.3426 84.8356 23.5051C83.5293 15.6676 79.7381 10.6971 74.083 7.37627C68.428 4.05543 57.9542 2 45.0512 2C34.2986 2 18.1699 4.15051 13.8689 14.9031Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5562 29.9566C68.3377 29.9566 69.7819 28.5124 69.7819 26.7309C69.7819 24.9493 68.3377 23.5051 66.5562 23.5051C64.7746 23.5051 63.3304 24.9493 63.3304 26.7309C63.3304 28.5124 64.7746 29.9566 66.5562 29.9566Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5562 47.1607V26.7309H33.7609",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.95021,
    cy: 16.7992,
    rx: 6.93135,
    ry: 4.26545,
    transform: "rotate(-75 6.95021 16.7992)",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDal);
export default __webpack_public_path__ + "static/media/Dalí.5e8288c4.svg";
export { ForwardRef as ReactComponent };var _path, _path2, _path3, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 106,
    viewBox: "0 0 87 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8689 14.9031C10.6431 23.5051 11.7182 35.3329 27.8471 40.7092C39.1373 45.0102 48.8585 39.5958 52.5779 43.9349C55.8037 47.6983 50.1563 51.3212 55.8037 65.44C57.9542 70.8163 62.2552 72.9668 63.3305 79.4183C64.4057 85.8699 60.8889 94.9336 64.9433 100.923C67.9057 105.3 74.9141 105.368 75.1582 98.7729C75.4023 92.1774 78.384 92.3214 78.9216 88.558C79.4593 84.7946 77.2196 81.048 79.4593 77.2678C84.0692 68.638 85.4909 63.8095 84.8356 55.2251C84.3836 49.3041 83.2226 47.1607 83.2226 40.7092C83.2226 33.1824 86.1418 31.3426 84.8356 23.5051C83.5293 15.6676 79.7381 10.6971 74.083 7.37627C68.428 4.05543 57.9542 2 45.0512 2C34.2986 2 18.1699 4.15051 13.8689 14.9031Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5562 29.9566C68.3377 29.9566 69.7819 28.5124 69.7819 26.7309C69.7819 24.9493 68.3377 23.5051 66.5562 23.5051C64.7746 23.5051 63.3304 24.9493 63.3304 26.7309C63.3304 28.5124 64.7746 29.9566 66.5562 29.9566Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5562 47.1607V26.7309H33.7609",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.95021,
    cy: 16.7992,
    rx: 6.93135,
    ry: 4.26545,
    transform: "rotate(-75 6.95021 16.7992)",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDal);
export default __webpack_public_path__ + "static/media/Dalí.5e8288c4.svg";
export { ForwardRef as ReactComponent };